<div class="page-content">
    <div class="page-header">
        <h1>{{ title }}</h1>
        <div class="page-description">{{ subTitle }}</div>
    </div>
    <div class="page-body">
        <div class="container-fluid cards-container">
            <div class="row">
                <div class="col-sm-12 col-lg-6">
                    <chart-card
                        id="evolutionOriginFinancingChart"
                        [title]="texts.evolutionOriginFinancingChart.title"
                        [error]="chartError"
                        [isLoading]="!chartData()[0].organizationId"
                        [series]="chartSeries"
                        [dataLabels]="dataLabels"
                        [stacked]="true"
                        [yaxis]="yaxis"
                        [xaxisCategories]="xaxisCategories"
                        [precision]="texts.evolutionOriginFinancingChart.precision"
                        [xaxisTitle]="texts.evolutionOriginFinancingChart.xaxisTitle"
                        [customTooltip]="evolutionOriginFinancingCustomTooltip"
                        class="h-100">
                    </chart-card>
                </div>
                <div class="col-sm-12 col-lg-6">
                    <chart-card
                        id="distribSourcesFinanChart"
                        [title]="distribSourceFinanChartTitle"
                        [error]="distribSourceFinanChartError"
                        [isLoading]="!distribSourceFinanChartData()[0].organizationId"
                        [series]="distribSourceFinanChartSeries"
                        [dataLabels]="distribSourceFinanDataLabels"
                        [labels]="distribSourceFinanLabels"
                        [colors]="distribSourceFinanColors"
                        type="pie"
                        [unitTooltip]="texts.distribSourcesFinanChart.unitTooltip"
                        [fill]="{ opacity: 0.9 }"
                        cardClass="h-100"></chart-card>
                </div>
            </div>
            <div class="row">
                <div class="col-sm-12 col-lg-6">
                    <chart-card
                        id="evolGrantorRightsChart"
                        [title]="texts.evolGrantorRightsChart.title"
                        [error]="grChartError"
                        [isLoading]="!grantorRightsChartData()[0].organizationId"
                        [series]="grChartSeries"
                        [dataLabels]="grDataLabels"
                        [stacked]="true"
                        [yaxis]="grYaxis"
                        [xaxisCategories]="grXaxisCategories"
                        [precision]="texts.evolGrantorRightsChart.precision"
                        [grid]="evolGrantorRightsGrid"
                        [xaxisTitle]="texts.evolGrantorRightsChart.xaxisTitle"
                        [unitTooltip]="texts.evolGrantorRightsChart.unitTooltip"
                        class="h-100">
                    </chart-card>
                </div>
                <div class="col-sm-12 col-lg-6">
                    <chart-card
                        id="breakdownGrChart"
                        [title]="texts.breakdownGrChart.title"
                        [error]="breakChartError"
                        [isLoading]="!breakDownChartData()[0].organizationId"
                        [series]="breakChartSeries"
                        [dataLabels]="breakDataLabels"
                        [yaxis]="breakYaxis"
                        [type]="'bar'"
                        [plotOptions]="breakPlotOptions"
                        [xaxisLabels]="breackXaxisLabels"
                        [xaxisCategories]="breakXaxisCategories"
                        [precision]="texts.breakdownGrChart.precision"
                        class="h-100">
                    </chart-card>
                </div>
            </div>
            <div class="row">
                <div class="col-sm-12 col-lg-6">
                    <chart-card
                        id="evolDebtsChart"
                        [title]="texts.evolDebtsChart.title"
                        [error]="debtsChartError"
                        [isLoading]="!debtsChartData()[0].organizationId"
                        [series]="debtsChartSeries"
                        [dataLabels]="debtsDataLabels"
                        [stacked]="true"
                        [yaxis]="debtsYaxis"
                        [xaxisCategories]="debtsXaxisCategories"
                        [precision]="texts.evolDebtsChart.precision"
                        [grid]="debtsGrid"
                        [xaxisTitle]="texts.evolDebtsChart.xaxisTitle"
                        [unitTooltip]="texts.evolDebtsChart.unitTooltip"
                        class="h-100">
                    </chart-card>
                </div>
            </div>
        </div>
    </div>
</div>
